<template>
    <!-- 页面二级侧边栏 -->
    <div class="col-lg-3 col-md-3">
        <div class="service_sideber">
            <div class="appointment-content appointment_side_form">
                <!-- <h2>关于我们</h2> -->
                <div class="list-group">
                    <a v-for="(tab,index) in list" href="javascript:void(0)" class="list-group-item" :class="{active: active == index}" @click="tabClick(index)">
                        {{tab.menu_name || tab.product_class_name || tab.news_class_name}}
                        <span class="glyphicon glyphicon-menu-right pull-right" aria-hidden="true"></span>
                    </a>
                  </div>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: "page-aside",
        props: ['list','active'],
		methods:{
			tabClick(index){
                this.$emit('tabClick',index);
            }
		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/PageAside.vue